import { ICredentials, UpdateLoginSateActions } from '@westwing/appshell_types/customEventTypes';
import { OverlayId } from 'Types/types';
import { dispatchCustomEvent } from 'AppShell/communication';

export enum LOCAL_EVENTS {
    AUTH_UNBLOCK_DECLINED = 'AUTH_UNBLOCK_DECLINED',
}
export type LocalEvents = {
    [LOCAL_EVENTS.AUTH_UNBLOCK_DECLINED]: {};
};

export type LocalEventNames = keyof LocalEvents;
export const dispatchLocalEvent = <T extends LocalEventNames>(evtName: T, data: LocalEvents[T] = {}): void => {
    window.document.dispatchEvent(new CustomEvent<LocalEvents[LocalEventNames]>(evtName, data));
};
interface UseCustomEventReturnType {
    showDoiOverlay: () => void;
    hideOverlay: (overlayId: OverlayId) => void;
    updateUserData: (action: UpdateLoginSateActions) => void;
    showNotification: (message: string) => void;
    showAccountTransferOverlay: (credentials: ICredentials) => void;
    sendUnblockDeclined: () => void;
}

export const useCustomEvent = (): UseCustomEventReturnType => {
    // TODO Handle doi on MF side.
    const showDoiOverlay = () => {
        dispatchCustomEvent('UPDATE_OVERLAYS', {
            detail: {
                action: 'SHOW',
                id: OverlayId.DOUBLE_OPT_IN_OVERLAY,
            },
        });
    };

    const hideOverlay = (overlayId: OverlayId) => {
        dispatchCustomEvent('UPDATE_OVERLAYS', {
            detail: {
                action: 'HIDE',
                id: overlayId,
            },
        });
    };

    const updateUserData = (action: UpdateLoginSateActions) => {
        dispatchCustomEvent('UPDATE_LOGIN_STATE', { detail: { action } });
    };

    const showNotification = (message: string) => {
        dispatchCustomEvent('NOTIFICATION', {
            detail: {
                displayType: 'default',
                action: 'SHOW',
                message,
            },
        });
    };

    const showAccountTransferOverlay = (credentials: ICredentials) => {
        dispatchCustomEvent('SHOW_BLOCKED_USER_OVERLAY', {
            detail: { credentials },
        });
    };

    const sendUnblockDeclined = () => {
        dispatchLocalEvent(LOCAL_EVENTS.AUTH_UNBLOCK_DECLINED);
    };

    return {
        showDoiOverlay,
        hideOverlay,
        updateUserData,
        showNotification,
        showAccountTransferOverlay,
        sendUnblockDeclined,
    };
};
